import { Auth } from "aws-amplify";
import { startSubmit, stopSubmit } from "redux-form";
import { call, delay, put } from "redux-saga/effects";

import { MiniMessageBox } from "../../../../MiniMessageBox";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* authnzUpdatePassword(username: string, confirmation_code: string, password: string): Generator<any, any, any> {
  return yield Auth.forgotPasswordSubmit(username, confirmation_code, password);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* authnzSetNewPasswordWorker(action: any): Generator<any, any, any> {
  const form = "UpdatePasswordForm";
  const { payload, navigate } = action;

  try {
    yield put(startSubmit(form));

    const { confirmation_code, password, username } = payload;

    yield call(authnzUpdatePassword, username, confirmation_code, password);
    yield put(stopSubmit(form));

    navigate("/");
    yield delay(200);
    yield put(
      MiniMessageBox.showMiniBoxMessage({ show: true, type: "success", message: "Your password was updated successfully. Please login." }),
    );
  } catch (error) {
    yield put(stopSubmit(form));
    if (error instanceof Error) {
      yield put(MiniMessageBox.showMiniBoxMessage({ show: true, type: "error", message: error.message }));
    }
  }
}
